export default __webpack_public_path__ + "static/lcd-piece-1-4740e56fccb43eb6172d600e89ba185c.jpg";